import { useTranslation } from 'react-i18next'

import { Card, CardTitle } from '@reveni-io/reveni-ui'

import MenuCard from '../MenuCard/MenuCard'
import ReasonsList from './ReasonsList/ReasonsList'
import * as Styles from './styles'

const ReasonsCard = ({
  title,
  icon,
  reasons = [],
  loading,
  shouldShow = true,
  shouldShowExport = true,
  onExport,
  onClickReason,
  reasonType,
}) => {
  const { t } = useTranslation()

  if (!shouldShow) return null

  return (
    <Card showBorder={false}>
      <CardTitle>
        <Styles.Title>
          {icon}
          {t(title)}
        </Styles.Title>
        {shouldShowExport && <MenuCard cardName={t(title)} onExport={onExport} />}
      </CardTitle>
      <ReasonsList loading={loading} reasons={reasons} onClickReason={onClickReason} reasonType={reasonType} />
    </Card>
  )
}

export default ReasonsCard
